/**
 * Engine Art QC measures — pack-agnostic pixel metrics.
 * Art Lab `character-qc` / Contract are façades that apply pack thresholds.
 */
export {
  frameHeight,
  solidCount,
  measureDirContinuity,
  measureProportionQuality,
  type ContinuityReport,
  type ProportionReport,
} from "./continuity";
export {
  measureRectRead,
  measureToneBands,
  countIsolatedPixels,
  type RectReadReport,
  type ToneBandsReport,
} from "./readability";

/** Best Y-align Hamming over opaque mismatches — catches idle+shiftY fakes. */
export function hammingAfterBestYAlign(a: string[], b: string[]): number {
  let best = Number.POSITIVE_INFINITY;
  for (let dy = -8; dy <= 8; dy++) {
    let d = 0;
    for (let y = 0; y < 64; y++) {
      const ty = y + dy;
      const rowA = a[y]!;
      for (let x = 0; x < 64; x++) {
        const ca = rowA[x]!;
        const cb = ty >= 0 && ty < 64 ? b[ty]![x]! : ".";
        const oa = ca !== ".";
        const ob = cb !== ".";
        if (oa || ob) {
          if (!oa || !ob || ca !== cb) d++;
        }
      }
    }
    best = Math.min(best, d);
  }
  return best;
}
